// @flow

import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import { fragments as transfersStandardOrderStatusFragments } from "../../application/apps/TransferPrintingApp/components/TransfersStandardOrderStatus/graph";

const markOrderAsTransfersStandardManualPrintingCompleted: any = graphql(
  gql`
    mutation($orderId: ID!) {
      markOrderAsTransfersStandardManualPrintingCompleted(orderId: $orderId) {
        errors {
          orderId
        }
        updatedOrder {
          ...TransfersStandardOrderStatus_order
        }
        succeeded
      }
    }
    ${transfersStandardOrderStatusFragments.order}
  `,
  {
    name: "markOrderAsTransfersStandardManualPrintingCompleted"
  }
);

export default markOrderAsTransfersStandardManualPrintingCompleted;
